<template>
  <div class="note-class">
    <Header
      title="学生教室借用"
      type="0"
      route="/restRooms/index"
    ></Header>
    <div class="asids">
      <span class="c_span"
        >{{ this.teachingBuildingName }} {{ this.classroomname }} ({{
          this.classroomnumber
        }})</span
      >
      <span class="c_span">容量：{{this.seatnumber}}人</span>
    </div>
    <van-field
      v-model="phone"
      label="联系电话"
      input-align="right"
      placeholder="请输入电话号"
    />
    <van-field
      v-model="person"
      label="审核人"
      input-align="right"
      placeholder="请点击选择"
      @click="peoplePop = true"
      readonly
    />
    <van-field
      v-model="remark"
      label="备注"
      input-align="right"
      placeholder="请点击填写"
      @click="
        note = true;
        textNote = remark;
      "
    />
    <van-field
      name="fileList"
      input-align="right"
      class="upload-line"
      label="上传附件"
    >
      <template #input>
        <van-uploader
          v-model="fileList"
          accept="*"
          :after-read="afterRead"
          :max-size="2 * 1024 * 1024"
          @oversize="onOversize"
          :max-count="1"
        />
      </template>
    </van-field>
    <div class="fo">
      <button @click="Sub()">提交申请</button>
    </div>
    <van-popup v-model="note" position="bottom">
      <div class="popNote">
        <div>
          <i class="closeIcon" @click="note = false"></i>备注
          <i class="conIcon" @click="confirmNote()"></i>
        </div>
        <textarea v-model="textNote" placeholder="请填写"></textarea>
      </div>
    </van-popup>
    <van-popup v-model="peoplePop" position="bottom">
      <div class="apply-pop">
        <div class="pop-title popNote">
          <i class="closeIcon" @click="peoplePop = false"></i>
          <p>审核人</p>
          <i class="conIcon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            @click="personTap($event, index)"
            v-for="(item, index) in personList"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";
export default {
  data() {
    return {
      baseMessObj:{},
      showSfdmt: false,
      peoplePop: false,
      jylcsmPop: false, 
      showJyyt:false,
      note:false,  
      phone:"",
      person:"",
      personId: "",
      reset: "",
      resetId: "",
      remark:"",
      textNote: "",
      personList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      fileList: [],
      classroomid: this.$route.query.classroomId,
      teachingBuildingName:this.$route.query.teachingBuildingName,
      classroomname:this.$route.query.classroomname,
      classroomnumber:this.$route.query.classroomnumber,
      seatnumber:this.$route.query.seatnumber,
      borrwdate:this.$route.query.borrwdate,
      starToEndNode:this.$route.query.starToEndNode
    };
  },
  methods: {
    resetCancel() {
      this.peoplePop = false;
      this.person = this.reset;
      this.personId = this.resetId;
    },
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.personList[res].isBtn == 0) {
        this.personList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.personList[res].isBtn == 1) {
        this.personList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.personList) {
        if (this.personList[res].name == "全部") {
          this.personList[i].isBtn = 0;
          this.personList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.personList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.personList[i].isBtn == 1) {
          strList = strList.concat(this.personList[i].name);
          idList = idList.concat(this.personList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    async getPeople() {
      const params = {
        ywcode: !!this.$route.query.ywcode ? this.$route.query.ywcode : "007",
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      let concatList = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.personList = this.personList.concat(concatList);
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      this.file = file.file;
    },onOversize(file) {
      this.$toast.fail("文件大小不能超过2M");
    },
    confirmNote() {
      this.remark = this.textNote;
      this.note = false;
      this.textNote = "";
    },
    async Sub() {
      let formData = {
        classroomIds: this.$route.query.classroomid,
        week: this.$route.query.weeknode,
        applyReason: this.remark,
        nodeNumber: this.$route.query.startNode + this.$route.query.endnode,
        weekday: "",
        borrwdata:this.$route.query.borrwdate,
        phone: this.phone,
        userIds: this.person == "全部" ? "" : this.personId,
      };
      if (this.phone !== "" && this.remark !== "") {
        let reg = /^1[3456789]\d{9}|[0]{1}[0-9]{2,3}-[0-9]{7,8}$/;
        if (this.phone == "") {
          this.$toast("请输入手机号码");
        } else if (!reg.test(this.phone)) {
          this.$toast("手机格式不正确");
        } else {
          if (this.fileList.length > 0) {
            const ret = await Api.jsjysqUpload({
              file: this.file,
              filename: this.file.name
            });
            if (ret.code == "1") {
              const res = await Api.teachSaveBorrowingClassrooms(formData);
              this.state = res.data;
              if (res.code == "0") {
              } else {
                this.$router.push({
                  path: "/restRooms/borrowRulst"
                });
              }
            } else {
              this.$toast.fail(ret.msg);
              return;
            }
          } else {
            const res = await Api.teachSaveBorrowingClassrooms(formData);
            this.state = res.data;
            if (res.code == "0") {
            } else {
              this.$router.push({
                path: "/restRooms/borrowRulst"
              });
            }
          }
        }
      } else {
        this.$toast.fail("请填写完整");
        return false;
      }
    },
  },
  created() {
    this.getPeople();
  }
};
</script>
<style lang="less" scoped>
.note-class {
  /deep/.van-field__label {
    color: @attendance-color-1;
  }
}
.pop-title,
.popNote > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.note-class .person {
  padding: 10px 20px;
  margin-top: 51px;
}
.note-class .person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 15px;
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.note-class .person button.cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
.popNote i {
  width: 25px;
  height: 25px;
  padding: 13px;
}
.popNote textarea {
  height: 110px;
  padding: 16px;
  color: @attendance-color-2;
  width: 100%;
  box-sizing: border-box;
}
.note-class .van-overlay {
  background-color: rgba(0, 0, 0, 0);
}
.note-class .van-popup.van-popup--bottom {
  box-shadow: 0px -2px 2px 0px rgba(223, 223, 223, 0.5);
}
.popNote .closeIcon {
  background: url(../../../../../static/img/close.png) center center no-repeat;
  background-size: 25px 25px;
}
.popNote .conIcon {
  background: url(../../../../../static/img/confirm.png) center center no-repeat;
  background-size: 25px 25px;
}

.title {
  line-height: 34px;
  width: 90%;
  margin: 10px auto;
}
.title a {
  text-decoration: none;
  color: @attendance-color-4;
  font-size: 18px;
  font-weight: 600;
}
.apply-pop {
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  max-height: 40%;
  overflow-y: scroll;
}
.pop-title {
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  z-index: 9;
}
.title a i {
  text-decoration: none;
  color: @attendance-color-4;
  vertical-align: middle;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(../../../../assets/images/back_left.png) center center no-repeat;
  background-size: 100%;
  margin-right: 5px;
}
.asids {
  padding: 0 20px;
  margin-top: 20px;
}
.asids .c_span {
  display: block;
  color: @attendance-color-1;
  font-size: 18px;
  font-weight: 600;
}
.asids .c_span:nth-child(2) {
  color: @attendance-color-2;
  font-size: 12px;
  margin-bottom: 30px;
  margin-top: 10px;
}
.asids p {
  color: @attendance-color-1;
  font-size: 16px;
  width: 100%;
  display: inline-block;
  border-bottom: 1px solid @attendance-border-color-6;
  margin-top: 20px;
  padding-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.asids p span {
  color: @attendance-color-1;
  font-size: 16px;
}
.asids p input {
  width: 105px;
  border: none;
  outline: none;
  height: 24px;
  color: @attendance-color-1;
  font-size: 16px;
  text-align: right;
}
.asids p input::-webkit-input-placeholder {
  text-align: center;
}
.fo {
  width: 90%;
  margin-left: 5%;
}
.fo button {
  display: block;
  text-align: center;
  line-height: 44px;
  width: 90%;
  height: 44px;
  background: @attendance-background-color-1;
  color: @attendance-color-3;
  font-size: 16px;
  border-radius: 3px;
  position: fixed;
  bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/newPages/student/restRooms/borrowViwe.vue